import { render, staticRenderFns } from "./aliCertify.vue?vue&type=template&id=346147c6&scoped=true"
import script from "./aliCertify.vue?vue&type=script&lang=js"
export * from "./aliCertify.vue?vue&type=script&lang=js"
import style0 from "./aliCertify.vue?vue&type=style&index=0&id=346147c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346147c6",
  null
  
)

export default component.exports